module.exports = __webpack_public_path__ + "static/media/img_about_us_01.442852de.png";